import { createReducer, on } from '@ngrx/store';
import { ProductUnlockActions } from './unlock.actions';
import { ProductUnlockState, productUnlockState } from './unlock.state';

export const productUnlockReducer = createReducer(
  productUnlockState,
  on(
    ProductUnlockActions.reset,
    (): ProductUnlockState => ({
      ANCESTRY: undefined,
      DNA_360: undefined,
      DNA_PREMIUM: undefined,
      NUTRIGENETIC: undefined,
      PRODIGY: undefined,
      SPORTGENOMIC: undefined
    })
  ),
  on(
    ProductUnlockActions.update,
    (state, { product }): ProductUnlockState => ({ ...state, ...product })
  )
);
